export enum DesignFilesAction {
    Revision = 1,
    Approval = 2,
    CancelRevision = 3,
    Refund = 4,
    AIRevision = 5,
    AIRevisionPostApproval = 6,
}
